import React, { useState } from "react";
import { acccordianData } from "../data/data";

export default function Accordion({perguntas}){
    let[activeIndex, setActiveIndex] = useState(1)

    return(
            <div className="accordion">
                {perguntas?.slice(3,20)?.map((item,index)=>{
                    return(
                    <div className="accordion-item border rounded mt-2" key={index}>
                        <h2 className="accordion-header" id="headingTwo">
                            <button className={`${activeIndex === item.id ? '' : 'collapsed'} accordion-button border-0 bg-light`} type="button" onClick={()=>setActiveIndex(item.id)}>
                                {item.titulo}
                            </button>
                        </h2>
                        <div id="collapseTwo" className={`${activeIndex === item.id ? 'show' : ''} accordion-collapse border-0 collapse`}>
                            <div className="accordion-body text-muted">
                                {item.descricao}
                            </div>
                        </div>
                    </div>
                    )
                })}
            </div>
    )
}